import styled, {css} from "styled-components";

export const FilterItemTitleDefaultBox = styled.span<{isChecked: boolean}>`
  margin-left: 10px;
  font-size: 1.5rem;
  ${({theme}) => theme.font.presets.medium};
  color: ${props => props.theme.colors.text};
  ${props => props.isChecked ? css`
    color: ${props => props.theme.colors.textLight};
    ${props => props.theme.font.presets.bold};
  ` : ''}
`;
